<template>
    <two-factor-layout>

        <two-factor-card v-if="currentPage === 'intro'"
                         :title="title"
                         :subtitle="subtitle">

            <p class="font-semibold mb-8 text-body-sm">{{ introBold }}</p>
            <p class="mb-16 text-body-sm">{{ intro }}</p>

            <simple-button
                class="w-full mt-24 mb-16"
                display="secondary"
                look="primary"
                type="button"
                @click="enableTwoFactor"
            >
                {{ introButton }}
            </simple-button>

            <p class="mx-auto w-fit" :class="{ 'text-body-sm' : footerSmall }" v-html="footer"></p>
        </two-factor-card>

        <two-factor-card
            v-if="currentPage === 'verify'"
            :title="title"
            :subtitle="subtitle"
        >

            <div class="flex flex-col font-medium mb-16">
                <ul class="numbered-list start-index1">
                    <li v-html="verifyStep1" class="mb-24"></li>
                    <li v-html="verifyStep2" class="mb-24"></li>
                </ul>

                <div class="self-center mb-24" v-html="qrCode"></div>

                <ul class="numbered-list start-index3">
                    <li v-html="verifyStep3" class="mb-10"></li>
                </ul>

                <qr-code-challenge :largerText="true" @code-valid="nextPage"></qr-code-challenge>
            </div>

            <p class="mx-auto w-fit" :class="{ 'text-[14px]' : footerSmall }" v-html="footer"></p>
        </two-factor-card>

        <two-factor-card v-if="currentPage === 'recovery'"
                         :title="title"
                         :subtitle="subtitle">

            <div class="flex flex-col mb-16">
                <qr-recovery-codes
                    :largerText="true"
                    :recoveryCodes="this.recoveryCodes"></qr-recovery-codes>
            </div>

            <p class="mx-auto w-fit" :class="{ 'text-[14px]' : footerSmall }" v-html="footer"></p>
        </two-factor-card>

    </two-factor-layout>
</template>

<script>
import QrCodeChallenge from '../components/ui/QrCodeChallenge.vue';
import QrRecoveryCodes from '../components/ui/QrRecoveryCodes.vue';
import TwoFactorLayout from './TwoFactorLayout.vue';
import TwoFactorCard from './TwoFactorCard.vue';
import SimpleButton from '../components/ui/SimpleButton.vue';

export default {
    components: {
        'qr-code-challenge': QrCodeChallenge,
        'qr-recovery-codes': QrRecoveryCodes,
        'two-factor-layout': TwoFactorLayout,
        'two-factor-card': TwoFactorCard,
        'simple-button': SimpleButton,
    },
    props: {
        title: {
            type: String,
            required: true
        },
        subtitle: {
            type: String,
            required: false
        },
        introBold: {
            type: String,
            required: true
        },
        intro: {
            type: String,
            required: true
        },
        introButton: {
            type: String,
            required: true
        },
        footer: {
            type: String,
            required: false
        },
        footerSmall: {
            type: Boolean,
            required: false,
            default: false
        },
        verifyStep1: {
            type: String,
            required: true
        },
        verifyStep2: {
            type: String,
            required: true
        },
        verifyStep3: {
            type: String,
            required: true
        },
    },
    data: function () {
        return {
            qrCode: null,
            recoveryCodes: null,
            currentPageNumber: 1,
            totalPageCount: 3,
        }
    },
    computed: {
        currentPage() {
            return ['intro', 'verify', 'recovery'][this.currentPageNumber - 1];
        }
    },
    methods: {
        nextPage() {
            const nextPage = this.currentPageNumber + 1;
            if (nextPage <= this.totalPageCount) {
                this.currentPageNumber = nextPage;
            }
        },
        activateTwoFactor(complete) {
            axios.post(route('app.activate-2fa'))
                .then(async (response) => {
                    this.qrCode = response.data.qrCode;
                    this.recoveryCodes = response.data.recoveryCodes;
                    complete();
                })
        },
        enableTwoFactor() {
            this.activateTwoFactor(this.nextPage);
        },
        continueToApp() {
            window.location.href = "/";
        },
    },
}
</script>

<style scoped>
.start-index1 {
    counter-reset: section;
}

.start-index3 {
    counter-reset: section 2;
}

.numbered-list {
  list-style: none;
  padding: 0;
}

.numbered-list li {
  position: relative;
  padding-left: 35px;
}

.numbered-list li::before {
  counter-increment: section;
  content: "";
}

.numbered-list li::after {
  content: counter(section);
  position: absolute;
  left: 0;
  top: 0px;
  width: 25px;
  height: 25px;
  border-radius: 13%;
  background-color: #f2f2f7;
  color: black;
  text-align: center;
  line-height: 25px;
  font-size: smaller;
}
</style>
